import { computed, Injectable, signal } from '@angular/core';
import { StateService } from '../state/state.service';

@Injectable({
  providedIn: 'root',
})
export class DemoModeManagerService {
  private demoMode = signal(null);
  demoModeEnabled = computed(() => !!this.demoMode());

  constructor(private state: StateService) {
    const demoMode = localStorage.getItem('demoMode');
    if (demoMode) {
      this.demoMode.set(demoMode === 'true');
    }
  }

  public enableDemoMode(): void {
    localStorage.setItem('demoMode', 'true');
    this.state.set({
      servers: [
        {
          id: 999999999,
          name: 'Demo Server',
          code: 'demo',
          end_time: 0,
          status: 'active',
          game: 'fivem',
          product_id: '10',
          tier: 'core',
        },
      ],
    });
    // Manual state change required to bypass the server list check in the server guard
    // before redirecting to dashboard, and before the demo profile has loaded
    this.demoMode.set(true);
    setTimeout(() => {
      // this.router.navigate(['dashboard']);
      window.location.href = '/dashboard'; // redirect to dashboard
    });
  }

  public disableDemoMode(url: string = '/profile'): void {
    localStorage.setItem('demoMode', 'false');
    this.demoMode.set(false);
    setTimeout(() => {
      // this.router.navigate(['profile']);
      window.location.href = url; // redirect to dashboard
    });
  }

  public isDemoModeEnabled(): boolean {
    return this.demoMode();
  }
}
